import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaterialMaster } from 'src/app/shared/models/material-master';
import { DataService } from 'src/app/shared/services/data-service/data.service';

@Component({
  standalone: false,
  selector: 'material-input',
  templateUrl: './material-input.component.html',
  styleUrls: ['./material-input.component.scss'],
})
export class MaterialInputComponent implements OnInit {
  keyword = 'FullName';
  data: MaterialMaster[];
  isLoading: boolean;
  @Input() error: string = '';
  @Input() selectedValue: string = '';
  @Output() selectedValueChange = new EventEmitter<string>();

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    if (this.selectedValue) {
      this.selectedValueChange.emit(this.selectedValue);
    }
  }

  selectEvent(item: any) {
    this.selectedValue = item.MARA_MATNR_MaterialNumber
      ? item.MARA_MATNR_MaterialNumber
      : item;
    this.selectedValueChange.emit(this.selectedValue);
  }

  async onChangeSearch(val: string) {
    this.selectedValue = '';
    this.selectedValueChange.emit(this.selectedValue);

    this.isLoading = true;
    this.data = await this.dataService.searchMaterial(val.toUpperCase());
    this.isLoading = false;
  }

  onCleared(e: any) {
    this.selectedValue = '';
    this.selectedValueChange.emit(this.selectedValue);
  }

  onFocused(e: any) {
    // do something when input is focused
  }
}

